module.exports = __webpack_public_path__ + "img/my_class_icon.ce9121a8.png";